import React from 'react';
import { DecorationArea } from '../../../../app/domain/Design/DecorationArea';
import { FillTarget } from '../../../../app/domain/Design/FillTarget';
import DecorationAreaPanel from '../../steps/customize/DecorationAreaPanel';
import NameEditorFields from './NameEditorFields';

interface Props {
  activeFillTarget: FillTarget;
  canvasId: string;
  decorationArea: DecorationArea;
  nameFonts: any;
  allFonts: any;
  hiddenFontsIds: any;
}

const NameEditor = (props: Props) => {

  const decorationArea = props.decorationArea;

  return <div className="name-editor">
    <DecorationAreaPanel decorationArea={decorationArea}>
      <NameEditorFields
        activeFillTarget={props.activeFillTarget}
        canvasId={props.canvasId}
        decorationArea={decorationArea}
        allFonts={props.allFonts}
        nameFonts={props.nameFonts} 
        hiddenFontsIds={props.hiddenFontsIds}/>
    </DecorationAreaPanel>
  </div>;

}

export default NameEditor;